<template>
    <div v-if="$globalConstants.components?.Settings" :class="getLayoutClass">
        <div class="page-container" :style="pageStyle">
            <AdsenseAdvertisementDisclosure
                :isDbl="$globalConstants.host['domain_id'] === 2"
            />
            <div
                class="navigation-handler"
                :class="{ 'has-partner': $globalConstants.host.rtl_header }"
            >
                <PartnerNav v-if="$globalConstants.host.rtl_header" />
                <GhostWriterNav v-bind="navigationProps" />
            </div>

            <keep-alive>
                <router-view
                    :host="$globalConstants.host"
                    :host-id="$globalConstants.host.id"
                ></router-view>
            </keep-alive>

            <div class="footer-handler">
                <GhostWriterFooter />
            </div>
        </div>
    </div>
</template>

<script>
import { mediaQueriesMixin, routeMixin } from '@/ghost-mixins';
import GhostWriterNav from '@organisms/Navigation/GhostWriterNav/GhostWriterNav.vue';
import GhostWriterFooter from '@organisms/Footer/GhostWriterFooter.vue';
import AdsenseAdvertisementDisclosure from '@organisms/SEOArticlePartials/partials/AdsenseAdvertisementDisclosure.vue';
import PartnerNav from '@organisms/Navigation/PartnerNav/PartnerNav.vue';

export default {
    name: 'GhostWriterTemplateApp',
    mixins: [routeMixin, mediaQueriesMixin],
    components: {
        PartnerNav,
        AdsenseAdvertisementDisclosure,
        GhostWriterFooter,
        GhostWriterNav,
    },
    computed: {
        showSideColumn() {
            return (
                !this.isMobileDevice() &&
                this.$globalConstants.components?.Settings?.pageLayout ===
                    'sidebars layout'
            );
        },
        getLayoutClass() {
            return this.showSideColumn ? 'sidebars-layout' : '';
        },
        navigationProps() {
            return this.$globalConstants.components['GhostWriterNav'] || [];
        },
        pageStyle() {
            return {
                // background: this.$globalConstants.components.Settings
                //     ? this.$globalConstants.components.Settings['background']
                //     : '',
                background: '#ffffff',
            };
        },
    },
};
</script>

<style lang="scss">
@import '@/sass/_themes.scss';
@import '@/sass/mixins';
@import '@/sass/font-mixin';
@import '@/sass/font-variables';
@import '@/sass/color-variables';
@import '@/sass/_base.scss';
@import '@/sass/_reset.scss';
@import '@/sass/components/card-container';
@import '@/sass/components/content-column';

.page__container {
    max-width: 1280px;
}

/*! purgecss start ignore */
.theme-ghost-writer {
    --white: #fff;
    --black: #000;
    --primary: #09090b;
    --secondary: #71717a;
    --background: rgba(230, 230, 230, 0.3490196078);
    --secondary-background: rgba(230, 230, 230, 0.5019607843);
    --tertiary-background: #f4f4f5;
    --highlight: #e11d48;
    --border-color: #e4e4e5;
    --disabled: #ffdf8a;
}

.vue-suspense-wrapper {
    width: 100%;
}

.interlinking {
    text-decoration: underline;
    color: #e11d48;
    font-weight: 600;
}

/*! purgecss end ignore */
</style>

<style lang="scss" scoped>
.sidebars-layout {
    display: grid;
    grid-template-columns: auto 1000px auto;
    .page-container {
        grid-column: 2;
    }
}

.page-container {
    position: relative;
    align-items: center;
    display: flex;
    flex-direction: column;
}
.navigation-handler {
    width: 100%;
    height: 52px;
    position: sticky;
    top: 0;
    z-index: 10;

    &.has-partner {
        height: unset;
    }
}

.footer-handler {
    width: 100%;
}
</style>
